import { z } from "zod";

export const shippingSchema = z.object({
  name: z.string().min(1, "Shipping zone name is required"),
  description: z.string().optional().default(""),
  countries: z.array(z.string()).default([]),
});
